module.exports = __webpack_public_path__ + "static/media/edit.c6887705.svg";